function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Arrow Left"
}, React.createElement("path", {
  d: "M17.336 18.664L12.184 13.5l5.153-5.164L15.75 6.75 9 13.5l6.75 6.75z",
  "data-name": "Path 4",
  fill: "#fff"
}), React.createElement("path", {
  d: "M0 0h27v27H0z",
  "data-name": "Path 5",
  fill: "none"
}));

var SvgArrowLeft = function SvgArrowLeft(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 27 27"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/arrowLeft.5af99c56.svg";
export { SvgArrowLeft as ReactComponent };